module.exports = __webpack_public_path__ + "img/pin-grey.be61352f.svg";